module.exports = __webpack_public_path__ + "img/programme4.4d6f8a8e.png";